import { PublicPage } from '../base.js';

export class PasswordReset extends PublicPage {
  static timl = `
    section.auth-page[aria-labelledby="password-reset-title"]
      .stacked-form.auth-form.auth-status
        header.auth-header
          h1#password-reset-title Check your inbox
          p We sent you a secure link to create a new password. It may take a minute to arrive.
        a.auth-primary.auth-primary-link[href="/login"] Back to login
        p.auth-muted-link
          span Didn't get the email?
          a[href="/forgot-password"] Try again
  `;
}
